import { render, staticRenderFns } from "./BingZhuangTu.vue?vue&type=template&id=cdf97778&scoped=true&"
import script from "./BingZhuangTu.vue?vue&type=script&lang=js&"
export * from "./BingZhuangTu.vue?vue&type=script&lang=js&"
import style0 from "./BingZhuangTu.vue?vue&type=style&index=0&id=cdf97778&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdf97778",
  null
  
)

export default component.exports